import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PackagePricingStep = ({ handleFormData,
  values,
  setValue,
  register,
  error,
  clearErrors,
  control,
  trigger
}) => {
  return (
    <>
      <h5>Set Your Desired Net Price</h5>
      <p className="good_day_para mt-2">Please enter the amount you wish to receive from the sale. Our commission and any applicable fees will be added on top of this amount to form the advertised price.</p>
      <p>For example, if you wish to net a certain amount, the final advertised price will include our commission and applicable fees. These will be deducted from the final selling price, and the remainder will be your net proceeds.</p>
      <div className="row">
        <>
          <div className="col-md-12">
            <span className="popup_input_label">
              Min Price
            </span>
          </div>
          <div className="col-md-12">
            <input
              type="number"
              min="100"
              name="MinPriceWillingToPay"
              // defaultValue={values.MinPriceWillingToPay}
              className="popup_input"
              id="MinPriceWillingToPay"
              {...register("MinPriceWillingToPay", {
                valueAsNumber: true,
              })}
              onChange={(e) => {
                clearErrors("MinPriceWillingToPay");
                handleFormData(e);
              }}
            />
            {error.MinPriceWillingToPay && (
              <span className="err-msg">
                {error?.MinPriceWillingToPay?.message}
              </span>
            )}
          </div>
          <div className="col-md-12">
            <span className="popup_input_label">
              Max Price<span className="required-field"></span>
            </span>
          </div>
          <div className="col-md-12">
            <input
              type="number"
              min="100"
              name="MaxPriceWillingToPay"
              // defaultValue={values.MaxPriceWillingToPay}
              className="popup_input"
              id="ItemPrice"
              {...register("MaxPriceWillingToPay", {
                required: "This field is required.",
                validate: {
                  maxNumber: (value) => {
                    if (parseFloat(value) <= 100) {
                      return "Maximum price should not be less than or equal to $100";
                    }
                    trigger("MaxPriceWillingToPay");
                  },
                },
              })}
              onChange={(e) => {
                clearErrors("MaxPriceWillingToPay");
                handleFormData(e);
              }}
            />
            <span className="err-msg">
              {error?.MaxPriceWillingToPay?.message}
            </span>
          </div>
        </>
      </div>

    </>
  );
}

export default PackagePricingStep;
